import { render, staticRenderFns } from "./Billing-Receipt.vue?vue&type=template&id=288cae6a&scoped=true&"
import script from "./Billing-Receipt.vue?vue&type=script&lang=js&"
export * from "./Billing-Receipt.vue?vue&type=script&lang=js&"
import style0 from "./Billing-Receipt.vue?vue&type=style&index=0&id=288cae6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288cae6a",
  null
  
)

export default component.exports